export type AppInfoState = {
    version?: string
}

export const InitialAppInfoState : AppInfoState = {
    version: undefined
}